import styles from './NewRecord.module.css';

export const NewRecord = () => {
  return <div className={styles.textRecord}>новый рекорд</div>;
};
